<template>
  <div>
    <v-layout row wrap justify-start>
      <v-flex xs12 sm4 pa1 v-for="(site, i) in reversedWebsites" :key="i" class="pa-2">
        <v-card class="mb-4 card" :class="{ close: site.close }">
          <a v-if="!site.close" :href="site.url" target="_blank">
            <v-img :src="site.image" aspect-ratio="1"></v-img>
          </a>
          <div v-else>
            <v-img :src="site.image" aspect-ratio="1"></v-img>
          </div>

          <v-card-title primary-title class="title">
            <div>
              <h3 class="headline mb-0 work-title">{{site.name}}</h3>
              <div class="work-desc">{{ site.description }}</div>
              <div class="work-tech">{{ site.teck }}</div>
            </div>
          </v-card-title>

          <!-- <v-card-actions>
            <v-btn v-if="!site.close" flat block color="orange" :href="site.url" target="_blank">見る</v-btn>
            <v-btn v-else flat block color="black" href="javascript: void(0);">閉鎖</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  computed: {
    reversedWebsites() {
      return this.websites.slice().reverse();
    }
  },
  data: () => ({
    websites: [
      {
        image: require("../assets/nobilabo.png"),
        name: "blog",
        teck: "PHP WordPress",
        url: "https://lab.nobi.site/",
        description: "ブログ"
      },
      {
        image: require("../assets/cowoo.png"),
        name: "cowoo",
        teck: "PHP Laravel MySQL",
        url: "https://cowoo.shop/",
        description: "ドロップシッピング",
        close: true
      },
      {
        image: require("../assets/sozai.png"),
        name: "のびのびそざい",
        teck: "WordPress Vue.js",
        url: "https://sozai.nobi.site/",
        description: "フリー素材"
      },
      {
        image: "https://dummy.nobi.site/512/512/NO%20IMAGE?bg=7957d5&fg=FFFFFF&fsize=48&font=Noto%20Sans%20JP&weight=Black",
        name: "のびのびツールズ",
        teck: "Nuxt.js",
        url: "https://tools.nobi.site/",
        description: "WEB制作ツールとか"
      },
      {
        image: "https://dummy.nobi.site/512/512/%E3%83%80%E3%83%9F%E3%83%BC%E7%94%BB%E5%83%8F%E7%94%9F%E6%88%90%E3%81%99%E3%82%8B%E3%82%84%E3%81%A4?bg=ffdd57&fg=333333&fsize=36&font=Noto%20Sans%20JP&weight=Black",
        name: "ダミー画像生成するやつ",
        teck: "Nuxt.js",
        url: "https://dummy.nobi.site/",
        description: "フリー素材"
      },
      {
        image: "https://dummy.nobi.site/512/512/%E3%81%AE%E3%81%B3%E3%81%AE%E3%81%B3%E3%81%AE%E3%83%BC%E3%81%A8?bg=ff69b4&fg=FFFFFF&fsize=40&font=M%2B%202p&weight=Black",
        name: "のびのびのーと",
        teck: "Hugo NetlifyCMS",
        url: "https://note.nobi.site/",
        description: "雑記"
      },
      {
        image: require("../assets/littlebitcode.png"),
        name: "LittleBitCode",
        teck: "hugo",
        url: "https://little-bit-code.work/",
        description: "短いコードと説明",
        close: true
      },
      {
        image: "https://dummy.nobi.site/512/512/CSS%20%E2%86%92%20SCSS%20%0A%E5%A4%89%E6%8F%9B%E3%81%99%E3%82%8B%E3%82%84%E3%81%A4?bg=FFFFFF&fg=272343&fsize=56&font=Noto%20Sans%20JP&weight=Black",
        name: "CSS → SCSS 変換するやつ",
        teck: "Next.js",
        url: "https://css2scss.nobi.site/",
        description: "WEB制作ツール"
      },
      {
        image: "https://dummy.nobi.site/400/300/CSS%E3%82%92%0A%E3%82%A4%E3%83%B3%E3%83%A9%E3%82%A4%E3%83%B3%E3%81%AB%E3%81%99%E3%82%8B%E3%82%84%E3%81%A4?bg=fed702&fsize=26&font=Noto%20Sans%20JP&weight=Black",
        name: "CSSをインラインにするやつ",
        teck: "Next.js",
        url: "https://css-inliner.nobi.site/",
        description: "WEB制作ツール"
      },
      {
        image: "https://dummy.nobi.site/400/300/%E3%82%82%E3%81%98%E3%82%82%E3%81%98QR?bg=000000&fg=FFFFFF&fsize=36",
        name: "もじもじQR",
        teck: "Next.js",
        url: "https://moji2qr.nobi.site/",
        description: "WEB制作ツール"
      }
    ]
  })
};
</script>

<style lang="scss">

.v-card {
  // &:hover {
  //   opacity: 0.65;
  // }

  &.close{
    .v-image{
      opacity: 0.25;
    }
    background: #000;
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.card{
  position: relative;
  transition: transform 180ms ease, box-shadow 220ms ease;
  will-change: transform;

  &:not(.close):hover{
    transform: translateY(-6px) scale(1.02);
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.18);

    .title{
      opacity: 1;
      transform: translateY(0);
    }
  }

  .title{
    opacity: 0;
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    right: 0;
    transform: translateY(12px);
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
    color: #fff;
    padding: 1.1em 1em 0.9em;
    pointer-events: none;
    transition: opacity 180ms ease, transform 220ms ease;
  }

  .work-title{
    font-size: 1.15em;
    letter-spacing: 0.06em;
    display: inline-block;
    position: relative;
    padding-bottom: 0.25em;
  }

  .work-title::after{
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 48px;
    height: 3px;
    background: #ffd54f;
  }

  .work-desc{
    margin-top: 0.35em;
    color: rgba(255, 255, 255, 0.9);
  }

  .work-tech{
    margin-top: 0.35em;
    font-size: 0.9em;
    color: rgba(255, 255, 255, 0.8);
  }
}
</style>


